import {
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  AutocompleteArrayInput,
  ReferenceArrayInput,
  useNotify,
  useRedirect,
} from "react-admin";
import { useEffect, useState } from "react";
import { apiUrl } from "../../apiendpoint";

export const GroupRoleCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("access_token");

    if (!token) {
      notify("Not authenticated", { type: "warning" });
      return;
    }

    fetch(`${apiUrl}roles?range=[0,999]`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => {
        setRoles(
          data.map((r) => ({
            id: r.id,
            name: r.name,
          }))
        );
      })
      .catch(() =>
        notify("Failed to load roles", { type: "error" })
      );
  }, [notify]);

  return (
    <Create
      title="Assign Roles to Group"
      mutationOptions={{
        onSuccess: () => {
          notify("Roles assigned to group successfully", {
            type: "success",
          });
          redirect("list", "grouproles"); // ✅ redirect
        },
        onError: () => {
          notify("Error assigning roles", { type: "error" });
        },
      }}
    >
      <SimpleForm>
        {/* Select Group */}
        <ReferenceInput source="group_id" reference="groups" label="Group">
          <SelectInput optionText="name" />
        </ReferenceInput>

        {/* Searchable Roles (like permissions) */}
        
        <AutocompleteArrayInput
          source="role_id"
          label="Roles"
          choices={roles}
          optionText="name"
          optionValue="id"
          fullWidth 
        />
        
      </SimpleForm>
    </Create>
  );
};